const toDataURL = url =>
  fetch(url)
    .then(response => response.blob())
    .then(blob => URL.createObjectURL(blob));

const downloadImage = async (url, name = 'image.png') => {
  const a = document.createElement('a');
  a.href = await toDataURL(url);
  a.download = name;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

export default downloadImage;
